
import React, { useState, useCallback, useEffect, useRef } from 'react'
import { Row, Col, Form, FormControl, Button, Container, Image } from 'react-bootstrap';
import CaptchaComponent from '../../component/CaptchaComponent';
import { fetch } from '../../../utils';
import useRazorpay from "react-razorpay";
import CryptoJS from "crypto-js";
import { useNavigate } from 'react-router-dom';
import policies2 from '../../assets/pdfFile/Fund Raiser Final.pdf'


import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';  // Core styles
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';  // Default layout plugin
import '@react-pdf-viewer/default-layout/lib/styles/index.css';  // Default layout styles
import { pdfjs } from 'react-pdf'; // Import pdfjs to resolve the issue with pdfjs.version


import { Helmet } from "react-helmet";
import DonationBottomContant from './DonationBottomContant';
const DonateNow = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();  // Initialize the default layout plugin

  const Razorpay = useRazorpay();
  const navigate = useNavigate();
  const numberToWords = require('number-to-words');
  const [captchaValue, setCaptchaValue] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [headsData, setHeadsData] = useState();
  const [errorAmountMessage, setErrorAmountMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const getDonateHeads = async () => {
    try {
      setIsLoading(true);
      const response = await fetch('/donation/heads', 'get', null, null);
      setHeadsData(response.data.data.headList);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getDonateHeads();
  }, []);

  const [customAmount, setCustomAmount] = useState('');
  const [donationAmount, setDonationAmount] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const handleClick = (id) => {
    if (selectedItem !== id) {
      setCustomAmount('');
    }
    setSelectedItem(id);
    if (id === 0) {
      setDonationAmount(parseFloat(customAmount) || 0);
    } else if (headsData && headsData.find(item => item.donation_head_id === id)) {
      const selectedItemData = headsData.find(item => item.donation_head_id === id);
      setDonationAmount(parseFloat(selectedItemData.head_amount) || 0);
    }
    if (validationErrors.donationAmount) {
      setValidationErrors({ ...validationErrors, donationAmount: '' });
    }
  };
  const [validationErrors, setValidationErrors] = useState({
    fname: '',
    lname: '',
    email: '',
    mobile: '',
    address: '',
  });
  const [formData, setFormData] = useState({
    fname: '',
    lname: '',
    email: '',
    mobile: '',
    address: '',
    pan: '',
  });
  const amountText = numberToWords.toWords(donationAmount || + customAmount);
  // console.log('donationAmount', donationAmount)

  const handleAmountChange = (e) => {
    const enteredAmount = parseFloat(e.target.value);
    console.log("enteredAmount", enteredAmount);
    const selectedHead = headsData.find((i) => i.donation_head_id === selectedItem);
    if (selectedHead && enteredAmount < selectedHead.head_amount) {
    } else {
      setErrorAmountMessage('');
    }

    setDonationAmount(enteredAmount);
  };



  const validateForm = () => {
    const errors = {};
    let isValid = true;

    // if (selectedItem !== 0 && !donationAmount) {
    //   errors.donationAmount = 'Donation amount is required';
    //   isValid = false;
    // }        else if (selectedItem === 0 && (!customAmount || customAmount <= 0)) {
    //   errors.donationAmount = 'Enter donation amount';
    //   isValid = false;
    // } 

    if (selectedItem !== 0 && !donationAmount) {
      errors.donationAmount = 'Please select a donation head';
      isValid = false;
    } else {
      const selectedHead = headsData.find((item) => item.donation_head_id === selectedItem);
      if (selectedItem !== 0 && (!donationAmount || donationAmount < selectedHead.head_amount)) {
        errors.donationAmount = `Entered amount should be greater than or equal to ₹${selectedHead.head_amount}.`;
        isValid = false;
      } else if (selectedItem === 0 && (!customAmount || customAmount <= 0)) {
        errors.donationAmount = 'Enter donation amount';
        isValid = false;
      }
    }
    if (!formData.fname.trim()) {
      errors.fname = 'First Name is required';
      isValid = false;
    }
    if (!formData.lname.trim()) {
      errors.lname = 'Last Name is required';
      isValid = false;
    }
    if (!formData.email.trim()) {
      errors.email = 'email is required';
      isValid = false;
    } else if (!isValidemail(formData.email)) {
      errors.email = 'Invalid email address';
      isValid = false;
    }

    if (!formData.mobile.trim()) {
      errors.mobile = 'Mobile is required';
      isValid = false;
    }

    if (!formData.address.trim()) {
      errors.address = 'Address is required';
      isValid = false;
    }
    if (!captchaValue) {
      errors.captcha = 'Please complete the reCAPTCHA';
    }
    setValidationErrors(errors);
    return isValid;
  };
  const isValidemail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const displayRazorpay = useCallback(
    (result, key) => {
      try {
        const options = {
          key, // Enter the Key ID generated from the Dashboard
          amount: result.amount,
          currency: result.currency,
          name: "Muskaan",
          description: "online order of muskaan store",
          image: { logo: `logoimg` },
          order_id: result.id,
          handler: async (data) => {
            setIsLoading(true);
            setErrorMessage("");
            try {
              const body = {
                razorpayPaymentId: data.razorpay_payment_id,
                razorpayOrderId: data.razorpay_order_id,
                razorpaySignature: data.razorpay_signature
              };
              const response = await fetch(
                '/donation/verify',
                'POST',
                body,
                null
              );
              if (response == false) {
                setIsLoading(false);
                setErrorMessage(response.massage);
                return false;
              }
              setIsLoading(false);
              navigate('/thankyou');

            } catch (error) {
              setIsLoading(false);
              setErrorMessage("something went wrong");
            }
          },
          prefill: {
            name: result.notes.customer_name,
            email: result.notes.customer_email,
            contact: result.notes.customer_contact,
          },
          notes: {
            ...result.notes,
            address: "Muskaan, Plot No. 264-65, Behind Canara Bank, Neelbad, Bhopal, India – 462 044",
          },
          theme: {
            color: "#090909",
          },
        };
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
        setIsLoading(false);
      } catch (error) {
        setErrorMessage("something went wrong");
      }
    },
    [navigate] // Ensure to include navigate in the dependencies array
  );


  const [donatePlace, setDonatePlace] = useState('');
  const handleSubmit = async () => {
    try {
      if (validateForm()) {
        const body = {
          fname: formData.fname,
          lname: formData.lname,
          email: formData.email,
          mobile: formData.mobile,
          adderss: formData.address,
          donation_head_id: selectedItem,
          donation_amount: donationAmount || customAmount,
          pan_no: formData.pan_no,
        };
        setIsLoading(true); // Setting isLoading to true here
        const response = await fetch('/donation/save', 'POST', body, null);
        console.log('submited data', response)
        if (response) {
          setDonatePlace(response.data.data);
          displayRazorpay(response.data.data.order, response.data.data.RAZORPAY_KEY_ID);
        } else {
          setDonatePlace(response.data);
        }
        setIsLoading(false);
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };
  const parsnalInfoRef = useRef(null);
  const handleClick1 = () => {
    parsnalInfoRef.current.scrollIntoView({ behavior: 'smooth' });
  };
  const [selectedTab, setSelectedTab] = useState(4); // 'all', 'monthly', 'annual', 'other'

  // const handleTabClick = (tab) => {
  //   setSelectedTab(tab);
  //   setSelectedItem(null);
  // };
  const handleTabClick = (tabKey) => {
    setSelectedTab(tabKey);
    setSelectedItem(null); // Reset selected item when switching tabs
  };


  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>Muskaan - Donate Now</title>
        <meta name="twitter:title" content='Connect' />
        <meta name="description" content="muskaan ngo" />
        <meta name="theme-color" content="#E6E6FA" />
      </Helmet>

      <div className='bgpettern pb-5 page-margin page-heigh'>

        <Container className='pt-4'>
          {/* 
          <h4>Online Donations</h4>
          <p>Home  / Donate Now</p>
 */}






          <div className='row'>
            <div className='col-sm-12 col-lg-12 col-md-12'>
              <h2 className='my-2'>Mud School Building Restoration Fundraiser</h2>
              <iframe
                width="100%"
                height="400"
                src="https://www.youtube.com/embed/i1UH0qlBZ_Q?autoplay=1&mute=1"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>

            </div>
          </div>

          <div className='with_aside-border history'>

          </div>

          <div className='row'>
            <p>
              {/* <em> Your financial contribution fuels our initiatives and directly impacts the lives of those belonging to the marginalized communities.</em> */}
            </p>
            <div className='col-sm-12 col-lg-8 col-md-12'>
              <div className="button-list pt-2">

                <h5 className="mb-0 p-0"> <strong>Choose Contribution Amount <span className='text-danger'>*</span> </strong></h5>
                <Row className='mt-2 heads-section'  >

                  {/* <div className="tabs head-tab p-2">
         
                    <button onClick={() => handleTabClick('monthly')} className={selectedTab === 'monthly' ? 'active' : ''}>Monthly</button>
                    <button onClick={() => handleTabClick('annual')} className={selectedTab === 'annual' ? 'active' : ''}>Annually</button>
                    <button onClick={() => handleTabClick('one time')} className={selectedTab === 'one time' ? 'active' : ''}>One Time Donation</button>
                    <button onClick={() => handleTabClick('otherAmount')} className={selectedTab === 'otherAmount' ? 'active' : ''}>Other Amount</button>

                  </div>

                  {headsData?.map((i) => (
                    i.display_status && (
                      <Col sm={12} key={i.donation_head_id} className='px-1 py-0'>
                        {((selectedTab === 'all') || (selectedTab === 'monthly' && i.head_name.includes('Monthly')) || (selectedTab === 'annual' && i.head_name.includes('Annual')) || (selectedTab === 'one time' && !i.head_name.includes('Monthly') && !i.head_name.includes('Annual'))) && (
                      
                      <li onClick={handleClick1} className='w-100'>
                            <label
                              className={`daily-anadhaanam acc ${selectedItem === i.donation_head_id ? 'acc-active' : ''}`}
                              onClick={() => handleClick(i.donation_head_id)}
                            >
                              <input
                                type="radio"
                                name="donationOption"
                                value={i.donation_head_id}
                                checked={selectedItem === i.donation_head_id}
                                onChange={() => handleClick(i.donation_head_id)}
                              />

                              <Row>
                                <Col lg={10} sm={8} xs={9}>
                                  <div className="daily-text"
                                    dangerouslySetInnerHTML={{ __html: i.head_name.replace(/(Monthly|Annual)/g, '<span>$1</span>') }}
                                  />
                                </Col>
                                <Col lg={2} sm={4} xs={3} className='text-end'>
                                  <div>
                                    &nbsp; <strong>₹ {i.head_amount}</strong>
                                  </div>
                                </Col>
                              </Row>
                            </label>
                          </li>
                        )}
                      </Col>
                    )
                  ))}

 */}

                  <div className="tabs head-tab p-2">
                    <button onClick={() => handleTabClick(1)} className={selectedTab === 1 ? 'active' : ''}>Monthly</button>
                    <button onClick={() => handleTabClick(2)} className={selectedTab === 2 ? 'active' : ''}>Annually</button>
                    <button onClick={() => handleTabClick(3)} className={selectedTab === 3 ? 'active' : ''}>One Time Donation</button>
                    <button onClick={() => handleTabClick(4)} className={selectedTab === 4 ? 'active' : ''}>Mud school restoration</button>

                    <button onClick={() => handleTabClick('otherAmount')} className={selectedTab === 'otherAmount' ? 'active' : ''}>Other Amount</button>
                  </div>



                  {headsData?.map((i) => (
                    i.display_status && (
                      <Col sm={12} key={i.donation_head_id} className='px-1 py-0'>
                        {(
                          (selectedTab === 'other') ||
                          (selectedTab === i.tabno)
                        ) && (
                            <li onClick={handleClick1} className='w-100'>
                              <label
                                className={`daily-anadhaanam acc ${selectedItem === i.donation_head_id ? 'acc-active' : ''}`}
                                onClick={() => handleClick(i.donation_head_id)}
                              >
                                <Row>
                                  <Col lg={10} sm={8} xs={9}>
                                    <div className="daily-text"
                                      dangerouslySetInnerHTML={{ __html: i.head_name.replace(/(Monthly|Annual)/g, '<span>$1</span>') }}
                                    />
                                  </Col>
                                  {/* {i.head_amount > 0 && (
                                    <Col lg={2} sm={4} xs={3} className="text-end">
                                      <div>
                                        &nbsp; <strong>₹ {i.head_amount}</strong>
                                      </div>
                                    </Col>
                                  )} */}


                                  {(i.head_amount) > 0 ? (
                                    <Col lg={2} sm={4} xs={3} className="text-end">
                                      <div>
                                        &nbsp; <strong>₹ {i.head_amount}</strong>
                                      </div>
                                    </Col>
                                  ) : (
                                    <Col lg={10}>
                                      {/* Enter their amount */}
                                      <input
                                        type="number"
                                        // value={donationAmount}
                                        placeholder='Enter Amount'
                                        className='form-control'
                                        min="1"
                                        style={{ width: "100%" }}
                                        onChange={handleAmountChange}
                                      />
                                    </Col>
                                  )}


                                  {/* <Col lg={2} sm={4} xs={3} className='text-end'>
                                    <div>
                                      &nbsp; <strong>₹ {i.head_amount}</strong>
                                    </div>
                                  </Col> */}

                                </Row>
                              </label>
                            </li>
                          )}
                      </Col>
                    )
                  ))}





                  <Col sm={12}>
                    {((selectedTab === 'otherAmount')
                    ) && (
                        <>
                          <li className='w-100 mt-4'>
                            <h5>Enter Other Amount : </h5>
                            <label className={`daily-anadhaanam acc p-1 ${selectedItem === 0 ? 'acc-active' : ''}`}>
                              <input
                                type="radio"
                                name="donationOption"
                                value="other"
                                checked={selectedItem === 0}
                                onChange={() => handleClick(0)}
                              />
                              <div className="daily-text" style={{ width: '15px' }}>
                                <strong> <i className="fa fa-inr"></i> </strong>
                              </div>

                              <input
                                type='number'
                                min="1"
                                style={{ width: "100%" }}
                                placeholder='Type Your Own Amount'
                                className={`border-0 ${selectedItem === 0 ? 'acc-input-place acc-active' : ''}`}
                                onClick={() => handleClick(0)}
                                value={customAmount}
                                onChange={(e) => {
                                  // Limit the input to 5 digits
                                  const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                  const limitedNumber = inputNumber.slice(0, 10);
                                  setCustomAmount(limitedNumber);
                                }}
                              />
                            </label>

                          </li>
                        </>
                      )}

                  </Col>
                </Row>
              </div>

              {validationErrors.donationAmount && (
                <h6 className="error text-danger m-0 text-center pt-4">{validationErrors.donationAmount}</h6>
              )}

              {/* <div className='mt-1'>
                {selectedItem !== null && selectedItem !== 0 && (
                  < >
                    <strong
                      style={{ fontSize: '15px' }}
                      dangerouslySetInnerHTML={{ __html: selectedItem === 'other' ? 'other' : headsData.find(item => item.donation_head_id === selectedItem)?.head_name }}
                    /> &nbsp;

                    <input
                      type="number"
                      value={donationAmount}
                      readOnly
                      onChange={handleAmountChange}
                    />
                    {errorAmountMessage && <div style={{ color: 'red' }}>{errorAmountMessage}</div>}
                  </>
                )}
              </div> */}

            </div>


            <div className='col-sm-12 col-lg-4 col-md-12' ref={parsnalInfoRef}>
              <div>

                <div className='text-center'>
                  <h6 className='py-2 mt-2 main-color p-0 m-0 '>Your contribution amount: <i className="fa fa-inr"></i>   ₹  {donationAmount || customAmount || 0} </h6>
                  <h6 className='text-capitalize text-info'><em>Rupees {amountText} Only</em></h6>
                </div>

                <div className='parsnal-info' style={{
                  background: "#e9e9e9",
                  padding: "16px 14px"
                }}>

                  <h5 className='mb-0 p-0'>
                    <strong>Personal information <span className='text-danger'>*</span> </strong>
                  </h5>
                  <Form className='mt-3'>
                    <Row>
                      <Form.Group className="mb-3" as={Col} md="12">
                        <FormControl
                          type='text'
                          name='fname'
                          placeholder='First Name *'
                          className='contact-input'
                          value={formData.fname}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData({ ...formData, fname: value });
                            setValidationErrors((prevErrors) => ({
                              ...prevErrors,
                              fname: value.trim() ? '' : 'First Name is required',
                            }));
                          }}
                        />
                        {validationErrors.fname && <p className="error text-danger m-0">{validationErrors.fname}</p>}
                      </Form.Group>
                      <Form.Group className="mb-3" as={Col} md="12">
                        <FormControl
                          type='text'
                          name='lname'
                          placeholder='Last Name *'
                          className='contact-input'
                          value={formData.lname}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData({ ...formData, lname: value });
                            setValidationErrors((prevErrors) => ({
                              ...prevErrors,
                              lname: value.trim() ? '' : 'Last Name is required',
                            }));
                          }}
                        />
                        {validationErrors.lname && <p className="error text-danger m-0">{validationErrors.lname}</p>}
                      </Form.Group>
                      <Form.Group className="mb-3" as={Col} md="12">
                        <FormControl
                          type='email'
                          name='email'
                          placeholder='E-mail Address *'
                          className='contact-input'
                          value={formData.email}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData({ ...formData, email: value });
                            setValidationErrors((prevErrors) => ({
                              ...prevErrors,
                              email: value.trim() ? '' : 'email is required',
                            }));
                          }}
                        />
                        {validationErrors.email && <p className="error text-danger m-0">{validationErrors.email}</p>}
                      </Form.Group>


                      <Form.Group className="mb-3" as={Col} md="6">
                        <FormControl
                          type='number'
                          name='mobile'
                          placeholder='Mobile *'
                          className='contact-input'
                          value={formData.mobile}
                          onChange={(e) => {
                            let value = e.target.value;
                            // Ensure the value is not more than 10 digits
                            if (value.length > 10) {
                              value = value.slice(0, 10);
                            }
                            setFormData({ ...formData, mobile: value });
                            setValidationErrors((prevErrors) => ({
                              ...prevErrors,
                              mobile: value.trim() ? '' : 'Mobile is required',
                            }));
                          }}
                        />
                        {validationErrors.mobile && <p className="error text-danger m-0">{validationErrors.mobile}</p>}
                      </Form.Group>



                      <Form.Group className="mb-3" as={Col} md="6">
                        <FormControl
                          type='text'
                          name='pan_no'
                          placeholder='PAN No.'
                          className='contact-input'
                          value={formData.pan_no}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData({ ...formData, pan_no: value })
                          }}
                        />
                      </Form.Group>

                      <Form.Group className="mb-3" as={Col} md="12">
                        <Form.Control
                          as="textarea"
                          name='address'
                          placeholder='Address *'
                          rows={3}
                          className='contact-input'
                          value={formData.address}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData({ ...formData, address: value });
                            setValidationErrors((prevErrors) => ({
                              ...prevErrors,
                              address: value.trim() ? '' : 'Address is required',
                            }));
                          }}
                        />
                        {validationErrors.address && <p className="error text-danger m-0">{validationErrors.address}</p>}
                      </Form.Group>

                      <Form.Group as={Col} md="6">
                        {/* <CaptchaComponent onChange={handleCaptchaChange} /> */}
                        {/* {errors.captcha && <p className="error text-danger">{errors.captcha}</p>} */}
                      </Form.Group>

                      <Form.Group as={Col} md="12" >
                        <font color="red" size='2' >{errorMessage}</font>
                        <Button
                          className='btn main-bg text-white py-2 px-5 border-none border-0   w-100'
                          onClick={handleSubmit}
                          disabled={isLoading}
                        >
                          {isLoading ? 'Please wait...' : 'Continue to Payment'}
                        </Button>
                      </Form.Group>
                    </Row>
                  </Form>
                </div>

              </div>
            </div>


          </div>


          <div className='row'>
            <div className='col-sm-12'>
              <div className='pt-3'>
                <p>
                  <b>Help us restore and Conserve Muskaan NGO’s Earthen
                    School</b> for children who need it the most.
                </p>
                <p>
                  You can
                  support us rebuild not only safe walls but also spaces of
                  dignity, resilience and hope.
                  Know more about our Mud School restoration <a href='https://drive.google.com/file/d/13VW0blFnPuMETvAgvhq_AabtVp3RsYOQ/view' target='_blank'> here. </a></p>
              </div>
            </div>
          </div>
          <hr />

          <div className='mt-2 donate-img'>



            {/* <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`}>
              <Viewer
                fileUrl={policies2}
                plugins={[defaultLayoutPluginInstance]}  // Use the defaultLayoutPluginInstance here
              />
            </Worker> */}



            <DonationBottomContant />

          </div>


        </Container>
      </div>

    </>
  );
};

export default DonateNow;
